/* Bubble Club – purchase panel (quantity, variant, AJAX add-to-cart integrated with the theme cart drawer) */
const root = document.querySelector('.bcp');
const form = document.getElementById('bc-product-form');

if (root && form) {
  const dataEl = root.querySelector('[data-bcp-variants]');
  const data = dataEl ? JSON.parse(dataEl.textContent) : { variants: [], labels: {} };
  const L = data.labels || {};
  const qty = form.querySelector('[data-bcp-qty]');
  const minus = form.querySelector('[data-bcp-minus]');
  const plus = form.querySelector('[data-bcp-plus]');
  const addBtn = form.querySelector('[data-bcp-add]');
  const addLabel = form.querySelector('[data-bcp-add-label]');
  const msg = form.querySelector('[data-bcp-msg]');
  const idInput = form.querySelector('[data-bcp-id]');
  let busy = false;
  let msgTimer;

  const qMin = () => Math.max(1, parseInt(qty.min, 10) || 1);
  const qStep = () => Math.max(1, parseInt(qty.step, 10) || 1);
  const qMax = () => (qty.max ? parseInt(qty.max, 10) : Infinity);
  function setQty(n) {
    let v = parseInt(n, 10);
    if (!Number.isFinite(v)) v = qMin();
    v = Math.min(qMax(), Math.max(qMin(), v));
    qty.value = String(v);
    minus.disabled = v <= qMin();
    plus.disabled = v >= qMax();
  }
  if (qty) {
    minus.addEventListener('click', () => setQty((parseInt(qty.value, 10) || qMin()) - qStep()));
    plus.addEventListener('click', () => setQty((parseInt(qty.value, 10) || qMin()) + qStep()));
    qty.addEventListener('change', () => setQty(qty.value));
    qty.addEventListener('blur', () => setQty(qty.value));
    setQty(qty.value);
  }

  function applyVariant(id) {
    const v = data.variants.find((x) => String(x.id) === String(id));
    if (!v) return;
    root.querySelectorAll('[data-bcp-price]').forEach((el) => (el.textContent = v.price));
    document.querySelectorAll('#bc-snav [data-bcp-price]').forEach((el) => (el.textContent = v.price));
    const cmp = root.querySelector('[data-bcp-compare]');
    const save = root.querySelector('[data-bcp-save]');
    const saveAmt = root.querySelector('[data-bcp-save-amount]');
    if (cmp) { cmp.textContent = v.compare || ''; cmp.hidden = !v.save; }
    if (save) { save.hidden = !v.save || save.dataset.disabled === 'true'; if (saveAmt && v.save) saveAmt.textContent = v.save; }
    addBtn.disabled = !v.available;
    addLabel.textContent = v.available ? L.add : L.soldout;
    const dyn = root.querySelector('[data-bcp-dyn]');
    if (dyn) dyn.hidden = !v.available;
    const stock = root.querySelector('[data-bcp-stock]');
    if (stock) {
      stock.dataset.state = v.state;
      const lab = stock.querySelector('[data-bcp-stock-label]');
      if (lab) lab.textContent = v.state === 'instock' ? L.instock : v.state === 'backorder' ? L.backorder : L.soldout;
      const del = stock.querySelector('[data-bcp-delivery]');
      if (del) del.hidden = v.state === 'soldout';
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    window.history.replaceState({}, '', url.toString());
  }
  if (idInput && idInput.tagName === 'SELECT') {
    idInput.addEventListener('change', () => applyVariant(idInput.value));
  }

  function say(text, type) {
    clearTimeout(msgTimer);
    msg.textContent = text || '';
    msg.className = 'bcp__msg' + (type ? ' is-' + type : '');
    if (text) msgTimer = setTimeout(() => { msg.textContent = ''; msg.className = 'bcp__msg'; }, type === 'error' ? 10000 : 4000);
  }

  const eventsModule = import('@shopify/events').catch(() => null);
  const routes = (window.Theme && window.Theme.routes) || {};
  const cartAddUrl = (routes.cart_add_url || '/cart/add') + '.js';
  const cartUrl = (routes.cart_url || '/cart') + '.js';

  form.addEventListener('submit', async (e) => {
    if (e.submitter && !e.submitter.matches('[data-bcp-add]')) return;
    e.preventDefault();
    if (busy || addBtn.disabled) return;
    busy = true;
    addBtn.setAttribute('aria-busy', 'true');
    say('');

    const ev = await eventsModule;
    const fd = new FormData(form);
    if (qty) fd.set('quantity', String(parseInt(qty.value, 10) || 1));
    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((el) => el.dataset && el.dataset.sectionId)
      .filter(Boolean);
    if (sectionIds.length) fd.set('sections', sectionIds.join(','));
    const quantity = Number(fd.get('quantity')) || 1;

    let deferred = null;
    if (ev && ev.CartLinesUpdateEvent) {
      deferred = ev.CartLinesUpdateEvent.createPromise();
      form.dispatchEvent(new ev.CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: String(fd.get('id')), quantity }],
        promise: deferred.promise,
      }));
    }

    const refreshCart = () => fetch(cartUrl, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then((r) => r.json());

    try {
      const res = await fetch(cartAddUrl, {
        method: 'POST',
        body: fd,
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
      });
      const json = await res.json();
      if (!res.ok || json.status) {
        const text = json.description || json.message || "We couldn't add this to your cart. Please try again.";
        say(text, 'error');
        if (ev && ev.CartErrorEvent) form.dispatchEvent(new ev.CartErrorEvent({ error: text, code: 'INVALID' }));
        if (deferred) {
          refreshCart().then((cart) => deferred.resolve({
            cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: { didError: true, items: cart.items, source: 'bc-buy', itemCount: quantity },
          })).catch(deferred.reject);
        }
        return;
      }
      const cart = await refreshCart();
      if (deferred) {
        deferred.resolve({
          cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { items: cart.items, source: 'bc-buy', itemCount: quantity, sections: json.sections, didError: false },
        });
        say('Added to cart ✓', 'ok');
      } else {
        window.location.href = routes.cart_url || '/cart';
      }
    } catch (err) {
      console.error(err);
      say('Network error. Check your connection and try again.', 'error');
      if (deferred) deferred.reject(err);
      if (ev && ev.CartErrorEvent) form.dispatchEvent(new ev.CartErrorEvent({ error: 'Network error', code: 'SERVICE_UNAVAILABLE' }));
    } finally {
      busy = false;
      addBtn.removeAttribute('aria-busy');
    }
  });
}
